import { defineMessages } from 'react-intl';

const messages = defineMessages({
  removeBundleSuccessNotificationTitle: {
    description: '3PL Provider Bundle Remove Bundle Modal Success Notification Title',
    defaultMessage: '3PL Provider Bundle was removed from your account.',
    id: 'DTsI4c',
  },
  removeBundleSuccessNotificationContent: {
    description: '3PL Provider Bundle Remove Bundle Modal Success Notification Content',
    defaultMessage: 'You can add this bundle back to your account at any time.',
    id: 'BS33Mi',
  },
  removeBundleFailureNotificationContent: {
    description: '3PL Provider Bundle Remove Bundle Modal Failure Notification Content',
    defaultMessage: 'Failed to remove the 3PL Provider Bundle. Please contact support if the problem persists.',
    id: 'QRJ/PE',
  },
  cancelSubscriptionPlanViaSupport: {
    description: 'Cancellation modal for users who have the 3PL Provider Bundle enabled and connected clients',
    defaultMessage:
      'To cancel your ShipStation plan, including the 3PL Provider Bundle, you must complete the cancellation request form. Our support team will then begin the cancellation process for you. Click the <b>Request cancellation</b> button to begin.',
    id: 's+h0Sl',
  },
  cancelSubscriptionPlanViaSupportButton: {
    description: 'Cancellation action button',
    defaultMessage: 'Request cancellation',
    id: 'dA4ANJ',
  },
  willRemove3PLBundleImmediately: {
    description: 'Cancellation action button',
    defaultMessage:
      'By confirming cancellation, you will immediately lose access to the 3PL Provider Bundle and all of the related functionality. <b>If you have any pending client invitations, these will be automatically cancelled</b>. ',
    id: 'Sl69Yc',
  },
});

export default messages;
